/*
 * checkbox插件
 * 使用方法：
 * <label class="checkbox">
 *  <input type="checkboxt" name="" id="" checked disabled />
 * </label>
 */
define('widget/checkbox', ['jquery'], $ => {
    const $document = $(document);

    function init() {
        const checkBox = '.checkbox';
        const checkBoxInput = '.checkbox-input';

        const checkedCls = 'checked';
        const disabledCls = 'disabled';
        const hoverCls = 'hover';

        const $checkBoxInput = $(checkBoxInput);

        if (!$checkBoxInput.length) {
            return;
        }

        $checkBoxInput.each((index, item) => {
            const $checkBox = $(item).siblings(checkBox);
            $('<span class="icon"></span>').appendTo($checkBox);

            if ($(item).prop('checked')) {
                $checkBox.addClass(checkedCls);
            } else if ($(item).prop('disabled')) {
                $checkBox.addClass(disabledCls);
            }
        });

        $document.on('mouseenter', checkBox, function () {
            if ($(this).hasClass(disabledCls) || $(this).hasClass(checkedCls)) {
                return;
            }

            $(this).addClass(hoverCls);
        });

        $document.on('mouseleave', checkBox, function () {
            if ($(this).hasClass(disabledCls) || $(this).hasClass(checkedCls)) {
                return;
            }
            $(this).removeClass(hoverCls);
        });

        $document.on('click', checkBoxInput, function () {
            if ($(this).hasClass(disabledCls)) {
                return;
            }
            $(this).siblings(checkBox).toggleClass(checkedCls);
        });
    }

    init();
});

